import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppClient } from "../../model/AppClient";
import { AuthDTO } from "../../model/AuthDTO";
import { authModel } from "../../model/AuthModel";
import { AuthPaths } from "./AuthPaths";

export const AuthLoginDialog = (props: any) => {
  const appName: string = props.appName;
  const closeCallback: () => void = props.closeCallback;

  const [formData, setFormData] = useState<AuthDTO>({
    username: "",
    password: "",
  });

  const navigate = useNavigate();
  const appClient = new AppClient();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateForm = (): boolean => {
    return (
      formData.username !== "" &&
      formData.password !== "" &&
      validateEmail(formData.username)
    );
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    let jwtToken: string | void = await appClient.login(formData);
    if (!jwtToken) {
      console.error("Login failed");
      closeCallback();
      return;
    }

    authModel.setEmail(formData.username);
    authModel.setJwtToken(jwtToken);

    navigate(AuthPaths.loginRoute(appName));
  };

  return (
    <Box
      sx={{
        maxWidth: 500,
        margin: "0 auto",
        padding: 3,
        boxShadow: 3,
        borderRadius: 2,
        bgcolor: "background.paper",
      }}
    >
      <Typography variant="h5" align="center" mb={3}>
        Login
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            placeholder="Username"
            name="username"
            type="email"
            fullWidth
            value={formData.username}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            placeholder="Password"
            name="password"
            type="password"
            fullWidth
            value={formData.password}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} mt={2}>
          <Button
            type="submit"
            variant="contained"
            color="secondary"
            fullWidth
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};
